import { createContext, useContext, type ReactNode } from 'react';
import { useAuth } from '@/components/AuthProvider';
import { APAC_DEFAULT_TZ } from '@/lib/datetime';

const TimeZoneContext = createContext<string>(APAC_DEFAULT_TZ);

export function TimeZoneProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const tz = user?.timezone || APAC_DEFAULT_TZ;
  return <TimeZoneContext.Provider value={tz}>{children}</TimeZoneContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useTimeZone(): string {
  return useContext(TimeZoneContext);
}
